<template>
    <el-dialog :visible="visible" ref="DetailDialog" :modal-append-to-body="true" class="petty-cash-detail-dialog ah-detail-dialog" top="5vh" append-to-body @close="onDialogClose">
        <template slot="title" v-if="data">
            <el-row>
                <el-col :span="16">
                    <span style="padding-right: 5px; position: relative">
                        <span class="type-label" :class="getTypeClass(data.typ)">
                            {{ getTypeLabel(data.typ) }}
                        </span>
                    </span>
                    <span>零用現金 {{ data.systemNo }}</span>
                </el-col>
            </el-row>
        </template>
        <div class="detail-row header" />
        <div class="detail-row" v-if="data">
            <div class="detail-block">
                <table class="ah-basic-data-table" cellpadding="0" cellspacing="0" style="margin-bottom: 30px">
                    <tr>
                        <th>金額：</th>
                        <td>
                            <span style="font-size: 15pt; font-weight: bold; margin-right: 5px">
                                <Money :v="data.amt" />
                            </span>
                            <span>TWD</span>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ getTypeLabel(data.typ) }}日期：</th>
                        <td>
                            <span style="margin-right: 5px">{{ data.dat | dateFormater("YYYY-MM-dd") }} </span>
                        </td>
                    </tr>
                    <tr>
                        <th>銀行帳戶：</th>
                        <td>
                            <div class="bank-account-tpc">
                                {{ data.bankName }}
                            </div>
                        </td>
                    </tr>
                    <tr v-if="data.mem">
                        <th>備註：</th>
                        <td>
                            <pre style="margin: 2px 0">{{ data.mem ? data.mem : "(無)" }}</pre>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="detail-row footer" v-if="data">
            <el-row>
                <el-col :sm="14" style="font-size: 9pt; color: #666">
                    <div>資料日期：{{ data.crT_DAT | dateFormater("YYYY-MM-dd") }}</div>
                </el-col>
            </el-row>
        </div>
    </el-dialog>
</template>
<script>
import _ from 'lodash';
import { PettyCashLabelOptions } from '@/assets/commonData/options';

export default {
    name: 'PettyCashDetailDialog',
    props: {
        data: {
            type: Object,
            default: () => {},
        },
        visible: Boolean,
    },
    methods: {
        getTypeLabel(typ) {
            return _.find(PettyCashLabelOptions, ['typ', typ])?.label;
        },
        getTypeClass(typ) {
            return _.find(PettyCashLabelOptions, ['typ', typ])?.class;
        },

        onDialogClose() {
            this.$emit('close', false);
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.petty-cash-detail-dialog {
    .el-dialog {
        max-width: 610px !important;
    }
    .type-label {
        display: inline-block;
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
        border-radius: 12px;
        font-size: 9.5pt;
        color: #222;
        font-weight: 500;
        &.import {
            background-color: #cad1f1;
        }
        &.export {
            background-color: #c6ecc2;
        }
        &.arrival {
            background-color: #c1f365;
        }
        &.refund {
            background-color: #f5a85a;
        }
        &.export-payment {
            background-color: #ffe36c;
        }
        &.personnel-fee-payment {
            background-color: #dcc1fa;
        }
        &.salary-payment {
            background-color: #ffa0dc;
        }
    }
}
</style>
